import { Navigate, Route, Routes } from 'react-router-dom'
import BoxTruckBidAnalyticsPage from './BoxTruckBidAnalyticsPage'

export default function BoxTruckBidAnalyticsRoutes() {
    return (
        <Routes>
            <Route index element={<BoxTruckBidAnalyticsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
